import {
    Avatar,
    Box,
    Button,
    Dialog,
    Grid,
    Hidden,
    LinearProgress,
    Theme,
    Typography,
} from "@mui/material";
import {
    Fragment,
    useEffect,
    useState,
} from "react";
import {
    checkImageExists,
    maskInfo,
    toINR
} from "../utils/utilityFunctions";
import { Categories, ColorMap, UserDetails } from "../components/Cart/types";
import LoadingComponent from "../components/Cart/LoadingComponent";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../redux-store/reducers";
import { GetInvestmentUserDetails } from "../redux-store/types/api-types";
import { getInvestmentUserDetails } from "../redux-store/actions/funds";
import { useHistory, useRouteMatch } from "react-router";
import { GenerateOtpResponseBody, GetOrderPreviewResponseBody, OrderPreviewOpenFlowRes, PurchaseOrderDirectPlacementResponseBody } from "../redux-store/types/cart";
import { generateOtp, getOrderPreview, orderPreviewOpenFlow, paymentOpenFlowGenOtp, purchaseOrderDirectPlacement } from "../redux-store/actions/cart";
import PaymentItemInfo from "./PaymentItemInfo";
import { showError } from "../redux-store/actions/auth";
import { LoadingButton } from "@mui/lab";
import { getAbbreviatedName,} from "../components/commonComponents";

const initialCategories = [
    { label: "New Purchase", count: 0 },
    { label: "Additional Purchase", count: 0 },
    { label: "SWP", count: 0 },
    { label: "STP", count: 0 },
    { label: "Switch", count: 0 },
    { label: "Redemption", count: 0 }
]

const colorMap: ColorMap = {
    "low risk": "success.800",
    "very high risk": "error.500",
    "": "text.primary"
}

const totalAmount = 10000;
const totalUnits = 100


export default function PaymentDetails(): JSX.Element {
    const history = useHistory();
    const dispatch = useDispatch();
    const { params } = useRouteMatch();
    const { paymentId } = params as unknown as { paymentId: string };
    // const { clientCode = "", portfolioId = "" } = history.location.state as unknown as { clientCode: string, portfolioId: string };
    const [activeCategory, setActiveCategory] = useState<string>("New Purchase");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [orderPreviewData, setOrderPreviewData] = useState<OrderPreviewOpenFlowRes>({} as OrderPreviewOpenFlowRes)
    const [otpDetails, setOtpDetails] = useState<GenerateOtpResponseBody>({} as GenerateOtpResponseBody);
    const [purchaseOrderDirectPlacementDetails, setPurchaseOrderDirectPlacementDetails] = useState<PurchaseOrderDirectPlacementResponseBody>({} as PurchaseOrderDirectPlacementResponseBody)
    const [otpLoading, setOtpLoading] = useState<boolean>(false);


    const [userDetails, setUserDetails] = useState<UserDetails>({
        userName: "",
        userStatus: "",
        userMobile: "",
        userEmail: "",
        userAccountType: ""
    })

    // const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const locale = orderPreviewData?.currency_details?.result?.locale ?? "en-IN";
    const currencyCode = orderPreviewData?.currency_details?.result?.currencyCode ?? "INR";
    const clientCode = orderPreviewData?.clientCode ?? "";
    const portfolioId = orderPreviewData?.portfolioId ?? "";

    // const fetchUserDetails = async () => {
    //     if (clientCode) {
    //         const userDetailsResponse = await (dispatch(getInvestmentUserDetails(
    //             { clientCode, portfolioId }
    //         )) as unknown as Promise<GetInvestmentUserDetails>)

    //         if (Object.keys(userDetailsResponse).length) {
    //             setUserDetails({
    //                 userName: userDetailsResponse?.name ?? "",
    //                 userStatus: userDetailsResponse?.status ?? "",
    //                 userMobile: userDetailsResponse?.mobile ?? "",
    //                 userEmail: userDetailsResponse?.email ?? ""
    //             })
    //         }
    //     }
    // }

    // const fetchOrderPreview = async () => {
    //     const response = await (dispatch(getOrderPreview(paymentId ?? "")) as unknown as Promise<GetOrderPreviewResponseBody>)
    //     if (response?.isSuccess) {
    //         setOrderPreviewData(response)
    //     }
    // }

    const fetchOrderPreview = async () => {
        const response = await (dispatch(orderPreviewOpenFlow(paymentId ?? "")) as unknown as Promise<OrderPreviewOpenFlowRes>)
        if (response?.isSuccess) {
            setOrderPreviewData(response)
            setUserDetails({
                userName: response?.name ?? "",
                userStatus: response?.status ?? "",
                userMobile: response?.mobile ?? "",
                userEmail: response?.email ?? "",
                userAccountType: response?.accountType ?? ""
            })
        }
    }
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             setIsLoading(true)
    //             await Promise.allSettled([fetchOrderPreview(), fetchUserDetails()])
    //         } catch (error) {
    //             console.log("Error:", error)
    //         }
    //         finally {
    //             if (clientCode) {
    //                 setIsLoading(false)
    //             }
    //         }
    //     }

    //     fetchData()
    // }, [clientCode])

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true)
                dispatch({ type: 'LOGOUT_SUCCESS' });
                await fetchOrderPreview();
            } catch (error) {
                console.log("Error:", error)
            }
            finally {
                setIsLoading(false);
            }
        }

        fetchData();
    }, [])


    const handlePaymentConfirm = async () => {
        try {
            setOtpLoading(true);
            if (orderPreviewData?.otp_authentication_required) {
                const payload = {
                    order_cart_id: orderPreviewData?.cartId ?? '',
                    token: paymentId
                }

                const response = await (dispatch(paymentOpenFlowGenOtp(payload)) as unknown as Promise<GenerateOtpResponseBody>)

                setOtpDetails(response);

                if (!response?.isSuccess) {
                    dispatch(showError(response?.message ?? ''))
                    return
                }
                history.push('validatePaymentOtp', {
                    paymentId,
                    cartId: orderPreviewData?.cartId ?? '',
                    id: response?.id ? `${response?.id}` : "",
                    message: response?.message ?? "",
                    clientCode,
                    portfolioId
                })
            } else {
                const payload = {
                    cartId: orderPreviewData?.cartId ?? '',
                    token: orderPreviewData?.token ?? ''
                }

                const response = await (dispatch(purchaseOrderDirectPlacement(payload)) as unknown as Promise<PurchaseOrderDirectPlacementResponseBody>)

                setPurchaseOrderDirectPlacementDetails(response);

                if (!response?.isSuccess) {
                    dispatch(showError(response?.message ?? ''))
                    return
                };

                history.push('fund-payment', {
                    cartId: response?.cartId ?? "",
                    token: response?.token ?? "",
                    clientCode,
                    portfolioId
                })
            }
        } catch (e) {
            console.log('error', e);
            if (orderPreviewData?.otp_authentication_required) {
                dispatch(showError(otpDetails?.message ?? ''))
            } else {
                dispatch(showError(purchaseOrderDirectPlacementDetails?.message ?? ''))
            }
        } finally {
            setOtpLoading(false);
        }
    }

    return (
        <Box sx={{ padding: '30px 45px' }}>
            <Box>
                <Box sx={(theme: Theme) => ({ borderBottom: `0.5px solid ${theme.palette.customColors.pastelGrey}` })}>
                    <Typography
                        variant="h1"
                        sx={(theme: Theme) => ({
                            lineHeight: "32.5px",
                            color: theme.palette.text.primary,
                            mb: 1
                        })}
                    >
                        Payment Details
                    </Typography>
                </Box>
                {/* <Box
                    sx={(theme: Theme) => ({
                        marginTop: "30px",
                        paddingBottom: "15px",
                        borderBottom: `0.5px solid ${theme.palette.customColors.pastelGrey}`,
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: '20px',
                        overflowX: 'auto',
                        whiteSpace: 'nowrap',
                        scrollbarWidth: 'none', // Hide scrollbar in Firefox
                        '&::-webkit-scrollbar': {
                            display: 'none', // Hide scrollbar in WebKit browsers
                        },
                    })}
                >
                    <Typography
                        component="span"
                        variant="body_500"
                        sx={{
                            letterSpacing: '0.02px',
                            marginRight: '0.3rem',
                            lineHeight: '20px'
                        }}
                    >
                        {`Purchase Type - New Purchase`}
                    </Typography>


                </Box> */}

                {/* payment order details and user details */}

                {isLoading
                    ?
                    <LinearProgress />
                    :
                    (
                        <Grid
                            container
                            sx={{ mt: 1 }}
                            spacing={3}
                        >
                            <Grid
                                item
                                xs={12}
                                lg={8}
                            >
                                <Box
                                    sx={(theme: Theme) => ({
                                        borderRadius: "20px",
                                        backgroundColor: theme.palette.common.white,
                                        padding: "25px 30px 35px 20px",
                                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                                    })}
                                >

                                    {orderPreviewData?.orders?.length > 0 && (
                                        <Box
                                            sx={{
                                                marginTop: "35px",
                                                display: "flex",
                                                flexDirection: "column",
                                                rowGap: "35px"
                                            }}
                                        >
                                            {orderPreviewData?.orders?.map((obj, index) => {
                                                const { fromSchemeName, toSchemeName, amcId, transactionType, amount, folioNumber, quantity, noOfInstallments } = obj;
                                                const showUnits = ['SWITCH', 'REDEMPTION'].includes(transactionType?.toUpperCase());
                                                const pauseCancel = ['XSIP/PAUSE', 'XSIP/CANCEL', 'STP/CANCEL', 'SWP/CANCEL'].includes(transactionType?.toUpperCase());

                                                const orderDetails = [
                                                    {
                                                        label: 'Transaction Type',
                                                        value: transactionType ?? '-'
                                                    },

                                                    {
                                                        label: pauseCancel ? "No. of installments" : showUnits ? 'Amount / Units' : 'Amount',
                                                        value: pauseCancel ? noOfInstallments ?? '0' : (showUnits ? `${toINR({ value: amount ?? 0, locale, currencyCode })} / ${quantity ? Number(quantity).toFixed(4) : 0}` : toINR({ value: amount ?? 0, locale, currencyCode }))
                                                    },
                                                    {
                                                        label: 'Folio Number',
                                                        value: folioNumber ?? '-'
                                                    },
                                                ]
                                                return (
                                                    <Fragment key={obj.id}>
                                                        <PaymentItemInfo
                                                            orderDetails={orderDetails ?? []}
                                                            fromSchemeName={fromSchemeName}
                                                            toSchemeName={toSchemeName ?? ''}
                                                            amcId={amcId}
                                                        />
                                                        {orderPreviewData?.orders?.length - 1 !== index && (
                                                            <Box sx={(theme: Theme) => ({ border: `0.1px solid ${theme.palette.text.secondary}B3` })} />
                                                        )}
                                                    </Fragment>
                                                )
                                            })}
                                        </Box>
                                    )}
                                    {orderPreviewData?.orders?.length === 0 && (
                                        <Box
                                            sx={{
                                                marginTop: "35px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Typography
                                                variant="body_600"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.text.primary
                                                })}
                                            >
                                                No Orders Found
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>

                            </Grid>
                            <Grid
                                item
                                xs={12}
                                lg={4}
                            >
                                <Box
                                    sx={(theme: Theme) => ({
                                        borderRadius: "20px",
                                        padding: "25px 30px 30px 30px",
                                        backgroundColor: theme.palette.common.white,
                                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                                    })}
                                >
                                    <Box
                                        sx={(theme: Theme) => ({
                                            display: "flex",
                                            columnGap: "15px",
                                            alignItems: "center",
                                            paddingBottom: "35px",
                                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                                        })}>
                                        {/* <Avatar
                                            sx={(theme: Theme) => ({
                                                ...theme.typography.h3,
                                                fontSize: "24px",
                                                width: "58px",
                                                height: "58px",
                                                lineHeight: "30px",
                                                letterSpacing: "0.02px",
                                                color: theme.palette.primary[500],
                                                backgroundColor: theme.palette.primary[50]
                                            })}
                                        >
                                            {getAbbreviatedName(userDetails.userName)}
                                        </Avatar> */}
                                           {getAbbreviatedName(userDetails.userName)}
                                        
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                rowGap: "5px",
                                            }}
                                        >
                                            <Typography
                                                variant="h2"
                                                sx={(theme: Theme) => ({
                                                    lineHeight: "25px",
                                                    letterSpacing: "0.01px",
                                                    color: theme.palette.text.primary
                                                })}
                                            >
                                                {maskInfo(userDetails.userName)}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px",
                                                    flexWrap: "wrap",
                                                }}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    {orderPreviewData?.investorType ?? ""}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        width: "3px",
                                                        height: "3px",
                                                        backgroundColor: "text.secondary",
                                                        alignSelf: "center",
                                                        borderRadius: "50%"
                                                    }}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    {portfolioId ?? ""}
                                                </Typography>
                                                {(`${orderPreviewData?.isFamilyHead ?? ""}`.toLowerCase() === "y") && (
                                                    <>
                                                        <Box
                                                            sx={{
                                                                width: "3px",
                                                                height: "3px",
                                                                backgroundColor: "text.secondary",
                                                                alignSelf: "center",
                                                                borderRadius: "50%"
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body_500"
                                                            sx={(theme: Theme) => ({
                                                                lineHeight: "20px",
                                                                letterSpacing: "0.02px",
                                                                color: theme.palette.text.secondary
                                                            })}
                                                        >
                                                            Head Of Family
                                                        </Typography>
                                                    </>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Hidden lgUp>
                                        {(Number(orderPreviewData?.transaction_amount ?? 0) !== 0) && (
                                            <Box
                                                sx={{
                                                    marginTop: "35px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    columnGap: "10px"
                                                }}
                                            >
                                                {/* <Typography
                                                variant="subtitle_500"
                                                sx={(theme: Theme) => ({
                                                    lineHeight: "14px",
                                                    color: theme.palette.text.secondary
                                                })}
                                            >
                                                Total {(['SWITCH', 'REDEMPTION'].includes(orderPreviewData?.orders?.[0]?.transactionType?.toUpperCase())) ? 'Amount / Units' : 'Amount'}
                                            </Typography>
                                            <Typography
                                                variant="h2"
                                                sx={(theme: Theme) => ({
                                                    lineHeight: "25px",
                                                    color: theme.palette.text.primary
                                                })}
                                            >
                                                {toINR({ value: (orderPreviewData?.transaction_amount ?? 0), locale, currencyCode })} {(['SWITCH', 'REDEMPTION'].includes(orderPreviewData?.orders?.[0]?.transactionType?.toUpperCase())) ? `/ ${orderPreviewData?.orders?.[0]?.quantity}` : ''}
                                            </Typography> */}
                                                <Typography
                                                    variant="subtitle_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "14px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    Total Amount
                                                </Typography>
                                                <Typography
                                                    variant="h2"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "25px",
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    {toINR({ value: (orderPreviewData?.transaction_amount ?? 0), locale, currencyCode })}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Hidden>
                                    <Hidden lgDown >
                                        {(Number(orderPreviewData?.transaction_amount ?? 0) !== 0) && (
                                            <Box
                                                sx={{
                                                    marginTop: "35px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    rowGap: "10px"
                                                }}
                                            >
                                                {/* <Typography
                                                variant="h3"
                                                sx={(theme: Theme) => ({
                                                    fontSize: "32px",
                                                    lineHeight: "40px",
                                                    color: theme.palette.text.primary
                                                })}
                                            >
                                                {toINR({ value: (orderPreviewData?.transaction_amount ?? 0), locale, currencyCode })} {(['SWITCH', 'REDEMPTION'].includes(orderPreviewData?.orders?.[0]?.transactionType?.toUpperCase())) ? `/ ${orderPreviewData?.orders?.[0]?.quantity}` : ''}
                                            </Typography>
                                            <Typography
                                                variant="body_500"
                                                sx={(theme: Theme) => ({
                                                    lineHeight: "16px",
                                                    color: theme.palette.text.secondary
                                                })}
                                            >
                                                Total {(['SWITCH', 'REDEMPTION'].includes(orderPreviewData?.orders?.[0]?.transactionType?.toUpperCase())) ? 'Amount / Units' : 'Amount'}
                                            </Typography> */}
                                                <Typography
                                                    variant="h3"
                                                    sx={(theme: Theme) => ({
                                                        fontSize: "32px",
                                                        lineHeight: "40px",
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    {toINR({ value: (orderPreviewData?.transaction_amount ?? 0), locale, currencyCode })}
                                                </Typography>
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "16px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    Total Amount
                                                </Typography>
                                            </Box>
                                        )}
                                    </Hidden>
                                    <LoadingButton
                                        loading={otpLoading}
                                        loadingPosition="start"
                                        variant="contained"
                                        fullWidth
                                        sx={(theme: Theme) => ({
                                            marginTop: "35px",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            backgroundColor: theme.palette.primary[500],
                                            color: theme.palette.textDark.primary,
                                            lineHeight: "22.5px",
                                            letterSpacing: "0.02px"
                                        })}
                                        disabled={false}
                                        onClick={handlePaymentConfirm}
                                    >
                                        Confirm
                                    </LoadingButton>
                                </Box>
                            </Grid>
                        </Grid>
                    )
                }
            </Box>
        </Box>
    )
}
